// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"YotnFq","bottomPart":"_3oJ5om"};